// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__34Ebw","productName":"Table_productName__2hoOx"};